module.exports = __webpack_public_path__ + "static/ide-737d505c3310953e4902e7a222d872bc.png";